import React, {useCallback, useEffect, useState} from 'react'
import {MunshiMenu} from "../components/Menu";
import {Button} from 'primereact/button';
import {axiosInstance} from "../utilities/AxiosConfig";
import {DataTable} from 'primereact/datatable';
import {ToastContainer} from 'react-toastify';
import {useSpinner} from "../context/SpinnerContext";
import {notify} from "../components/toast";
import {RadioButton} from "primereact/radiobutton";
import {TreeTable} from "primereact/treetable";
import {Column} from "primereact/column";
import {Sidebar} from "primereact/sidebar";
import {ViewImages} from "../components/Image/ImageUtils";
import {ExpensePrint} from "../print/ExpensePrint";
import {DuePrint} from "../print/DuePrint";
import {AccountTreePrint} from "../print/AccountTreePrint";
import {LedgerPrint} from "../print/LedgerPrint";
import Cookies from "js-cookie";
import {MonthSelect} from "../components/Select/MonthSelect";
import {CommissionPrint} from "../print/CommissionPrint";
import {Auths} from "../utilities/getAuthDep";


export function CustomerAccount({handle}) {
    const {loading, setLoading} = useSpinner();
    const [action, setAction] = useState("Balance");
    const [action1, setAction1] = useState(null);
    const [salesGroupList, setSalesGroupList] = useState([]);
    const [proceed, setProceed] = useState(false);
    const [balanceList, setBalanceList] = useState([]);
    const [ledger, setLedger] = useState([]);
    const [duesList, setDuesList] = useState([]);
    const [expenseList, setExpenseList] = useState([]);
    const [showLedger, setShowLedger] = useState(false);
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");
    const [selectedMonth, setSelectedMonth] = useState({id: 1, month: "January"});
    const [commissionList, setCommissionList] = useState([]);
    const [customer, setCustomer] = useState({});
    const [group, setGroup] = useState({id: 0, name: ""});
    const [bioData, setBioData] = useState({});
    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                // Fetch all data in parallel for better performance
                const [ bioRes] = await Promise.all([
                    axiosInstance.get('biodata/'),
                ]);
                setBioData(bioRes.data);
            } catch (error) {
                notify(error.message, "error");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);

    //login Level
    useEffect(() => {

        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database') || "Test");
    }, [])
    //loading

    //Load Customer
    useEffect(() => {
        setLoading(true)
        axiosInstance.get("/customerGroup/category/sales/").then((response) => {
            if (response.data && response.data.length > 0) {
                setSalesGroupList(response.data)
            } else {
                notify("No Sales Group Found", "error")
            }
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
            }
        )
    }, [])
    const handlePrintOptions = () => {
        switch (action) {
            case "Expenditure": {
                ExpensePrint(expenseList, bioData.name)
                break;
            }
            case "Dues": {
                DuePrint(duesList, bioData.name)
                break;
            }
            case "Commission": {
                CommissionPrint(commissionList, bioData.name, selectedMonth.month, group.name.trim())
                break;
            }
            default: {
                AccountTreePrint(balanceList, bioData.name)
            }
        }
    }
    const handleSecondOption = (e) => {
        const groupId = salesGroupList.find((group) => group.name === e.value).id
        setGroup({id: groupId, name: e.value})
        setAction1(e.value)
    }
    const ledgerHeader = () => {
        return (
            <div className="flex justify-content-end">
                <Button icon="pi pi-print" className="mr-1 pr-2"
                        onClick={() => LedgerPrint(ledger, bioData.name, customer.name, "All")}
                        disabled={!proceed || ledger.length === 0}/>
            </div>
        );
    };
    const loadLedger = (id) => {
        if (Number(id) > 0) {
            setLoading(true)
            axiosInstance.get(`/customer/id/${id}`).then((response) => {
                if (response.data) {
                    setCustomer(response.data)
                    axiosInstance.get(`/ledger/${id}`).then((response) => {
                        if (response.data && response.data.length > 0) {
                            setLedger(response.data)
                            setShowLedger(true)
                        } else {
                            notify("No Balance Found", "error")
                        }
                    }).catch((error) => {
                        notify(error.message, "error")
                    })
                } else {
                    notify("No Customer Found", "error")
                }
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(
                () => {
                    setLoading(false)
                }
            )

        }
    }
    const resetPage = useCallback(() => {
        setBalanceList([])
        setLedger([])
        setProceed(false)
        setDuesList([])
        setExpenseList([])
        setShowLedger(false)
        setAction1(null)

    })
    const applyAction = () => {
        resetPage()
        setShowLedger(false)
        setLoading(true)
        switch (action) {
            case "Balance": {
                axiosInstance.get(`/unitDues/total/balance`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setBalanceList(response.data.filter((d) => d.balance !== 0))
                    } else {
                        notify("No Balance Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                        setProceed(true)
                    }
                )
                break;
            }
            case "Bank": {
                axiosInstance.get(`/account/dues/type/B`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setBalanceList(response.data.filter((b) => b.balance !== 0))
                    } else {
                        notify("No Bank Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                        setProceed(true)
                    }
                )

                break;
            }
            case "Import": {
                axiosInstance.get(`/account/dues/type/I`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setBalanceList(response.data.filter((i) => i.balance !== 0))

                    } else {
                        notify("No Import Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                        setProceed(true)
                    }
                )
                break;
            }
            case "Assets": {
                axiosInstance.get(`/account/dues/type/A`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setBalanceList(response.data.filter((asset) => asset.balance !== 0))

                    } else {
                        notify("No Assets Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                        setProceed(true)
                    }
                )
                break;
            }
            case "Dues": {

                axiosInstance.get(`/account/dues/group/${group.id}`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setDuesList(response.data)

                    } else {
                        notify("No Dues Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                        setProceed(true)
                    }
                )
                break;
            }
            case "Expenditure": {
                axiosInstance.get(`/account/expenses/all/`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setExpenseList(response.data.filter((expense) => expense.total !== 0))
                    } else {
                        notify("No Expenditure Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                        setProceed(true)
                    }
                )
                break;
            }
            case "Commission": {
                axiosInstance.get(`/customerGroup/commission/${group.id}&${selectedMonth.id}`).then((response) => {
                    if (response.data && response.data.length > 0) {

                        setCommissionList(response.data.filter((commission) => commission.total !== 0))
                    } else {
                        notify("No Expenditure Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                        setProceed(true)
                    }
                )
                break;
            }
            default: {
                setProceed(false)
                setLoading(false)
            }
        }
    }
    const OptionSelect = () => {
        return (
            <>
                <div className="container flex flex-column xl:flex-row mb-3 w-full ">
                    <div className="flex flex-row mb-2 ml-5 gap-2 jutify-content-end md:mt-2 ">
                        <Button label="Proceed" icon="pi pi-sinc mr-2" onClick={() => applyAction()}
                                disabled={(group.id === 0 || !level.ledger()) && (action === "Dues" || action === "Commission")}/>
                        <Button label="Reset" icon="pi pi-refresh mr-2" onClick={() => resetPage()}/>
                        <Button icon="pi pi-print" className="mr-1 pr-2" onClick={() => handlePrintOptions()}
                                disabled={!proceed}/>
                    </div>
                    <div
                        className=" container shadow-5  border-round-md flex flex-grow-1 flex-column align-item-start p-2 m-2 xl:flex-row xl:justify-content-around xl:align-items-center ">
                        <div className="flex flex-row justify-content-evenly mb-1 ">
                            <RadioButton className=" pr-3" inputId="1" name="action" value="Balance"
                                         onChange={(e) => setAction(e.value)} checked={action === 'Balance'} disabled={!level.ledger()}/>
                            <label htmlFor="1" className=" ml-1 text-xs text-start">BALANCE</label>
                            <RadioButton className="pl-4 pr-3" inputId="2" name="action" value="Bank"
                                         onChange={(e) => setAction(e.value)} checked={action === 'Bank'} disabled={!level.cashier()}/>
                            <label htmlFor="2" className=" ml-1 text-xs text-start">BANK</label>
                            <RadioButton className="pl-4 pr-3" inputId="3" name="action" value="Import"
                                         onChange={(e) => setAction(e.value)} checked={action === 'Import'} disabled={!level.imports() && !level.cashier()}/>
                            <label htmlFor="3" className=" ml-1 text-xs text-start">IMPORT</label>
                        </div>
                        <div className="flex flex-row justify-content-evenly mb-1 ">
                            <RadioButton className="md:pl-4 pr-3" inputId="4" name="action" value="Assets"
                                         onChange={(e) => setAction(e.value)} checked={action === 'Assets'} disabled={!level.cashier()}/>
                            <label htmlFor="4" className=" ml-1 text-xs text-start">ASSETS</label>
                            <RadioButton className="pl-4 pr-3" inputId="5" name="action" value="Dues"
                                         onChange={(e) => setAction(e.value)} checked={action === 'Dues'} disabled={!level.cashier()}/>
                            <label htmlFor="5" className=" ml-1 text-xs text-start">DUES</label>
                            <RadioButton className="pl-4 pr-3" inputId="6" name="action" value="Expenditure"
                                         onChange={(e) => setAction(e.value)} checked={action === 'Expenditure'} disabled={!level.cashier()}/>
                            <label htmlFor="6" className=" ml-1 text-xs text-start">EXPENDITURE</label>
                            <RadioButton className="pl-4 pr-3" inputId="7" name="action" value="Commission"
                                         onChange={(e) => setAction(e.value)} checked={action === 'Commission'} disabled={!level.cashier()}/>
                            <label htmlFor="7" className=" ml-1 text-xs text-start">COMMISSION</label>
                        </div>
                    </div>
                </div>


            </>
        )
            ;
    }
    const OptionSalesGroupSelect = () => {
        return (
            <>
                <div
                    className="container shadow-7 border-round-md justify-content-start   flex flex-column lg:flex-row lg:justify-content-between">
                    <div className="flex flex-wrap gap-3">
                        {salesGroupList.map((saleGroup, i) => (
                            <div key={i} className="flex align-items-center">
                                <RadioButton inputId={i} name="action" value={saleGroup.name}
                                             onChange={(e) => handleSecondOption(e)}
                                             checked={action1 === saleGroup.name}/>
                                <label htmlFor={i} className="ml-2">{saleGroup.name}</label>
                            </div>
                        ))}
                    </div>
                    {action === "Commission" && <div className="flex flex-wrap gap-3">
                        <MonthSelect selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth}
                                     disable={group.id === 0}/>
                    </div>}
                </div>
            </>
        )

    }
    const ShowCommission = () => {
        if (!loading && proceed && action === "Commission" && commissionList.length > 0) {
            return (
                <>
                    <div className="container card h-full w-full">
                        <DataTable value={commissionList} size="small" tableStyle={{minWidth: '50rem'}} showGridlines
                                   stripedRows onRowClick={(e) => loadLedger(e.data.id)}
                                   paginator rows={10} scrollable scrollHeight="80vh">
                            <Column className="text-left text-xs md:text-base" field="name" header="Name"
                                    alignHeader={"left"}
                                    style={{width: '15%'}}></Column>
                            <Column className="text-right text-xs md:text-base" field="sale" header="Sale"
                                    alignHeader={"right"}
                                    style={{width: '10%'}}></Column>
                            <Column className="text-right text-xs md:text-base" field="purchase" header="Purchase"
                                    alignHeader={"right"}
                                    style={{width: '10%'}}></Column>
                            <Column className="text-right text-xs md:text-base" field="receipt" header="Receipt"
                                    alignHeader={"right"}
                                    style={{width: '10%'}}></Column>
                            <Column className="text-right text-xs md:text-base" field="bounced" header="Bounced"
                                    alignHeader={"right"}
                                    style={{width: '10%'}}></Column>
                            <Column className="text-right text-xs md:text-base" field="total" header="Total"
                                    alignHeader={"right"}
                                    style={{width: '15%'}}></Column>
                        </DataTable>
                    </div>
                </>
            )
        }
    }
    const ShowDues = () => {
        if (!loading && proceed && action === "Dues" && duesList.length > 0) {
            return (
                <>
                    <div className="card">
                        <TreeTable value={duesList} tableStyle={{minWidth: '50rem', height: '100%'}} scrollable={true}
                                   showGridlines paginator={true} rows={10} stripedRows={true}
                                   columnResizeMode={"expand"}
                                   onRowClick={(e) => loadLedger(e.node.data.id)}>
                            <Column className="text-left text-xs md:text-base" field="name" header="Name"
                                    expander></Column>
                            <Column className="text-right text-xs md:text-base" field="balance"
                                    header="Balance" alignHeader="right"></Column>
                            <Column className="text-right text-xs md:text-base" field="dues40" header="40-Days Dues"
                                    alignHeader="right"></Column>
                            <Column className="text-right text-xs md:text-base " field="dues40" header="60-Days Dues"
                                    alignHeader="right"></Column>
                        </TreeTable>
                    </div>
                </>
            )
        }
    }
    const ShowLedger = () => {
        const [showImage, setShowImage] = useState(false)
        const [mode, setMode] = useState("")
        const [invoiceId, setInvoiceId] = useState(0)
        const handleTableClick = (data) => {
            setMode(data.data.mode)
            setInvoiceId(data.data.invoiceId)
            if (data.data.invoiceId > 0) {
                setShowImage(true)
            }

        }
        if (ledger.length === 0) {
            return (
                <div className="card">
                    <div className="flex flex-row justify-content-center">
                        <h1>No Ledger Found</h1>
                    </div>
                </div>
            )
        } else if (showImage) {
            return (
                <>
                    {showImage ? <ViewImages invoice={invoiceId} mode={mode} showImage={showImage}
                                             setShowImage={setShowImage}/> : null}

                </>
            )
        } else {
            return (
                <>
                    <div className="card h-full">
                        <DataTable value={ledger} size="small" tableStyle={{minWidth: '50rem'}} showGridlines
                                   stripedRows onRowClick={(e) => handleTableClick(e)}
                                   paginator rows={25} scrollable scrollHeight="80vh" header={ledgerHeader}>
                            <Column className="text-left text-xs md:text-base" field="date" header="Date"
                                    style={{width: '15%'}}></Column>
                            <Column className="text-left text-xs md:text-base" field="invoiceId" header="Folio"
                                    style={{width: '5%'}}></Column>
                            <Column className="text-left text-xs md:text-base" field="mode" header="Mode"
                                    style={{width: '5%'}}></Column>
                            <Column className="text-end text-xs md:text-base" field="debit" header="Debit"
                                    alignHeader="right" style={{width: '15%'}}></Column>
                            <Column className="text-end text-xs md:text-base" field="credit" header="Credit"
                                    alignHeader="right" style={{width: '15%'}}></Column>
                            <Column className="text-end text-xs md:text-base" field="total" header="Balance"
                                    alignHeader="right" style={{width: '20%'}}></Column>
                            <Column className="text-left text-xs md:text-base" field="department" header="Department"
                                    style={{width: '10%'}}></Column>
                            <Column className="text-left text-xs md:text-base" field="comment" header="Comment"
                                    style={{width: '15%'}}></Column>
                        </DataTable>

                    </div>
                </>
            )
        }

    }
    useEffect(() => {
        setBalanceList([])
        setDuesList([])
        setExpenseList([])
        setCommissionList([])
        setLedger([])
        setGroup({id: 0, name: ""})

    }, [action])
    const ShowBalance = () => {
        if (!loading && proceed && (action === "Balance" || action === "Bank" || action === "Import" || action === "Assets") && balanceList.length > 0) {
            return (
                <>
                    <div className="container card h-full">

                        <TreeTable value={balanceList} tableStyle={{minWidth: '50rem', height: '100%'}}
                                   scrollable={true} showGridlines paginator={true} rows={10} stripedRows={true}
                                   columnResizeMode={"fit"}
                                   onRowClick={(e) => loadLedger(e.node.data.id)}>
                            <Column style={{width: '300px', height: '57px'}} field="name" header="Name"
                                    expander></Column>rma
                            <Column className="text-right" style={{width: '150px', height: '57px'}} field="balance"
                                    header="Balance"></Column>
                        </TreeTable>
                    </div>
                </>
            )
        }
    }
    const ShowExpenditure = () => {
        if (!loading && proceed && action === "Expenditure" && expenseList.length > 0) {
            return (
                <>
                    <div className="card">
                        <TreeTable value={expenseList} scrollable stripedRows scrollHeight="80vh"
                                   tableStyle={{minWidth: '50rem', height: '100%', width: '100vw'}} resizableColumns
                                   showGridlines columnResizeMode="expand"
                                   style={{fontSize: '12px'}}
                                   onRowClick={(e) => loadLedger(e.node.data.id)} paginator rows={15}>
                            <Column className="text-left text-xs md:text-sm" style={{width: '11%'}} field="name"
                                    header="Name" headerClassName="text-xs  " expander></Column>
                            <Column className="text-right " style={{width: '7%'}} field="total"
                                    header="Total" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="jan"
                                    header="Jan" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="feb"
                                    header="Feb" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="mar"
                                    header="Mar" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="apr"
                                    header="April" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="may"
                                    header="May" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="june"
                                    header="June" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="july"
                                    header="July" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="aug"
                                    header="Aug" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="sept"
                                    header="Sep" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="oct"
                                    header="Oct" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="nov"
                                    header="Nov" alignHeader="right"></Column>
                            <Column className="text-right " style={{width: '6%'}} field="dec"
                                    header="Dec" alignHeader="right"></Column>

                        </TreeTable>
                    </div>
                </>
            )
        }
    }
    const LedgerContent = () => {
        return (
            <div className="flex flex-nowrap flex-shrink-1 justify-content-start align-content-start">
                <div className="card flex justify-content-center">
                    <Sidebar visible={showLedger} onHide={() => setShowLedger(false)} position="right"
                             className="w-10">
                        <ShowLedger/>
                    </Sidebar>
                </div>
            </div>
        )
    }
    if (!loading) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                {showLedger && <LedgerContent/>}
                <div className="flex flex-column justify-content-start   h-auto w-full ml-2 mr-2">
                    <div className="flex flex-column">
                        <OptionSelect/>
                        {(action === "Dues" || action === "Commission") && salesGroupList.length > 0 &&
                            <OptionSalesGroupSelect/>}
                    </div>
                    <div className="flex flex-row justify-content-start w-full">
                        {action === "Dues" && proceed &&
                            <div className="flex flex-row justify-content-start w-full mr-2 ml-2">
                                <ShowDues/></div>}
                        {(action === "Bank" || action === "Balance" || action === "Import" || action === "Assets") && proceed &&
                            <div className="flex flex-row justify-content-start w-100">
                                <ShowBalance/>
                            </div>}

                        {action === "Expenditure" &&
                            <div className="flex flex-row justify-content-start w-100"><ShowExpenditure/>
                            </div>}
                        {action === "Commission" &&
                            <div className="flex flex-row justify-content-start w-100"><ShowCommission/>
                            </div>}
                    </div>

                </div>
            </>
        )
    }


}

export default CustomerAccount;

